import ApiClient from '../backend/ApiClient'
import { snackbar } from '../components/services/SnackbarService'
import affirm from '../core/Affirm'
import { IMedia } from '../definitions/Media'
import { ISignedURL, IUploadedFile, IUploadedResult } from '../definitions/Upload'

class UploadManagerClass {
    uploadFile = async (file: File, description: string, dimensions: string): Promise<IMedia> => {
        affirm(file, 'File missing')

        const result = await ApiClient.createMedia(file.name, file.size, description, dimensions)

        const res = await fetch(result.signedUrl, {
            method: 'PUT',
            headers: { 'Content-Type': `${file.type}` },
            body: file
        })

        if (res.status === 200) {
            await ApiClient.updateMedia({ ...result.media, fileIsUploaded: true })
            return result.media
        } else {
            snackbar.show({ severity: 'error', text: 'Unable to load file' })
            return null
        }
    }

    uploadContractFiles = async (signs: ISignedURL[], files: File[], contractID: number, contractUUID?: string): Promise<IUploadedResult> => {
        const uploadedFiles: IUploadedFile[] = []

        for (let i = 0; i < signs.length; i++) {
            const file = files[i]
            const sign = signs[i]

            const result = await ApiClient.createNewContractFile(contractUUID, file.name, file.size, signs[i].key)

            const res = await fetch(sign.url, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/pdf' },
                body: file
            })

            if (res.status === 200) {
                const uploadedFile = await ApiClient.setContractFile({ ...result, fileIsUploaded: true })
                uploadedFiles.push(uploadedFile)
            } else {
                snackbar.show({ severity: 'error', text: 'Unable to load file' })
                return null
            }
        }

        return {
            contractId: contractID,
            uploadedfiles: uploadedFiles,
            contractUUID: contractUUID
        }
    }
}

const UploadManager = new UploadManagerClass()
export default UploadManager
